import { render } from "./create.vue?vue&type=template&id=0e99e7ea&scoped=true"
import script from "./create.vue?vue&type=script&lang=ts"
export * from "./create.vue?vue&type=script&lang=ts"

import "./create.vue?vue&type=style&index=0&id=0e99e7ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e99e7ea"

export default script